export enum OrderType {
  /** Заказ */
  'Order' = 'Order',
  /** Приказ */
  'Decree' = 'Decree',
}
